import React from "react";
import { useTranslation } from "react-i18next";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "@/components/survey/Question";
import { MultipleChoiceQuestion } from "@/components/survey/questionTypes/core";

const QUESTION_ID = "glucometerOwnership";

declare module "@/contexts" {
  interface SurveyAnswers {
    glucometerOwnership?: "yes" | "no";
  }
}

const GlucometerOwnershipQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    { id: "yes", text: t("glucometerOwnership.options.yes") },
    { id: "no", text: t("glucometerOwnership.options.no") },
  ];

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionId={QUESTION_ID}
      questionText={t("glucometerOwnership.questionText")}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_GLUCOMETER_OWNERSHIP: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DIABETES_LIFESTYLE"],
  shouldShowQuestion: ({ partnerInfo }) =>
    partnerInfo?.configs?.BGM_ELIGIBILITY === "OFFERED",
  component: GlucometerOwnershipQuestion,
};
